import { render, staticRenderFns } from "./SettingsTransfer.vue?vue&type=template&id=188d3081&"
import script from "./SettingsTransfer.vue?vue&type=script&lang=js&"
export * from "./SettingsTransfer.vue?vue&type=script&lang=js&"
import style0 from "./SettingsTransfer.vue?vue&type=style&index=0&id=188d3081&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports